import './NotificationWidget.css';

class NotificationWidget {
    constructor(container, options = { timeout: 0 }) {
        this._container = container;
        this._options = options;
        this._content = document.createElement('div');
        this._container.appendChild(this._content);
        this._content.classList.add('notification-widget');
    }
    get content () {
        return this._content;
    }
    show () {
        if(this._options.timeout) {
            this._content.classList.add('notification-on');
            window.setTimeout(() => this.hide(), this._options.timeout);
        }
        else {
            this._content.classList.add('notification-on');
        }
    }
    hide () {
        this._content.classList.remove('notification-on');
    }
}

export default NotificationWidget;